/**
 * `devGuard` — keeps `/dev/**` out of the way when the overlay is off.
 *
 * Not a security boundary, and `DevMode` says so at length: the routes are in the
 * same bundle and the switch is a query parameter. What it buys is that a colleague
 * clicking around, or a stray link in a deck, cannot land on the trigger catalogue
 * and mistake it for a screen Orange asked for — S-20 is labelled "TIPAR · NU ESTE
 * UN SINGUR ECRAN" in the prototype for exactly that reason.
 *
 * Redirects to S-01 rather than showing anything. There is no 404 design in any
 * source and inventing one would be inventing a screen; `app.routes.ts` takes the
 * same position on unknown paths.
 */
import { inject } from '@angular/core';
import { RedirectCommand, Router } from '@angular/router';
import type { CanActivateFn } from '@angular/router';
import { DevMode } from '../dev/dev-mode';
import { ROUTE_FOR } from '../flow/flow-steps';

export const devGuard: CanActivateFn = () => {
  const dev = inject(DevMode);
  const router = inject(Router);

  return dev.enabled() ? true : new RedirectCommand(router.parseUrl(ROUTE_FOR['S-01']));
};
